export default "__VITE_PUBLIC_ASSET__d0db004b__"